import React from 'react';
import SEO from '../../components/SEO/SEO';
import MainNav from '../../components/MainNav/MainNav';
import Footer from '../../components/Footer/Footer';
import AnalyticsTracker from '../../components/Analytics/AnalyticsTracker';
import ContactForm from '../../components/ContactForm/ContactForm';
import { trackPhoneCall, trackEmailClick } from '../../components/Analytics/Analytics';
import { OFFICE_ADDRESS, OFFICE_MAPS_URL } from '../../config/office';
import './ContactPage.css';

const CONTACT_EMAIL = 'comercial@e-asy.es';

const ContactPage = ({ darkMode, toggleDarkMode }) => {
  const handlePhoneClick = () => {
    trackPhoneCall('+34 822 68 50 12');
  };

  const handleEmailClick = () => {
    trackEmailClick(CONTACT_EMAIL);
  };

  return (
    <>
      <SEO
        title="Contacto | Consultoría Tecnológica Gratuita en Canarias | E-ASY"
        description="Contacta con E-ASY para tu consultoría tecnológica gratuita. Tel: +34 822 68 50 12. Email: comercial@e-asy.es. Oficina en Carretera Santa María 22, Edificio Intech. Respuesta en 24h."
        keywords="contacto E-ASY Tenerife, consultoría tecnológica gratuita Canarias, teléfono E-ASY, email E-ASY, oficina Santa Cruz Tenerife, presupuesto tecnológico gratis"
        canonical="https://e-asy.es/contacto"
      />

      <AnalyticsTracker
        pageTitle="Contacto - E-ASY"
        pageLocation="/contacto"
        darkMode={darkMode}
      />

      <MainNav darkMode={darkMode} toggleDarkMode={toggleDarkMode} />

      <div className={`contact-page ${darkMode ? 'dark' : 'light'}`}>
        <section className={`servicios-hero ${darkMode ? 'dark' : 'light'}`}>
          <div className="servicios-hero-content">
            <div className="servicios-hero-text">
              <h1 className="servicios-hero-title">Contacta</h1>
              <p className="servicios-hero-subtitle">
                ¿Listo para transformar tu empresa? Nuestro equipo de expertos está aquí para ayudarte.
                Solicita tu consultoría gratuita y descubre cómo la tecnología puede impulsar tu negocio.
              </p>
              <div className="servicios-hero-stats">
                <div className="hero-stat">
                  <div className="hero-stat-number">24h</div>
                  <div className="hero-stat-label">tiempo respuesta</div>
                </div>
                <div className="hero-stat">
                  <div className="hero-stat-number">100%</div>
                  <div className="hero-stat-label">gratuito</div>
                </div>
                <div className="hero-stat">
                  <div className="hero-stat-number">5+</div>
                  <div className="hero-stat-label">canales contacto</div>
                </div>
              </div>
            </div>
            <div className="servicios-hero-video">
              <div className="servicios-hero-visual">
                <video autoPlay muted loop playsInline className="servicios-hero-video">
                  <source src="/videos/hero-contacto-v1.mp4" type="video/mp4" />
                  <source src="/videos/hero-contacto-v1.webm" type="video/webm" />
                  Tu navegador no soporta el elemento de video.
                </video>
              </div>
            </div>
          </div>
        </section>

        <div className="contact-main">
          <div className="contact-content">
            <div className="contact-form-section">
              <div className="form-header">
                <h2 className="form-title">Solicita tu consultoría gratuita</h2>
                <p className="form-subtitle">
                  Completa el formulario y nos pondremos en contacto contigo en menos de 24 horas
                </p>
              </div>

              <ContactForm darkMode={darkMode} />
            </div>

            <div className="contact-info-section">
              <div className="info-header">
                <h3 className="info-title">Información de contacto</h3>
                <p className="info-subtitle">
                  Estamos aquí para ayudarte. Contacta con nosotros de la forma que prefieras.
                </p>
              </div>

              <div className="contact-methods">
                <div className="contact-method">
                  <div className="method-content">
                    <h4 className="method-title">Teléfono</h4>
                    <p className="method-value">
                      <a href="tel:+34822685012" onClick={handlePhoneClick}>
                        +34 822 68 50 12
                      </a>
                    </p>
                    <p className="method-description">Lun-Vie 9:00 - 17:00</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-content">
                    <h4 className="method-title">Email</h4>
                    <p className="method-value">
                      <a href={`mailto:${CONTACT_EMAIL}`} onClick={handleEmailClick}>
                        {CONTACT_EMAIL}
                      </a>
                    </p>
                    <p className="method-description">Respuesta en 24h</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-content">
                    <h4 className="method-title">Oficina</h4>
                    <p className="method-value">
                      <a href={OFFICE_MAPS_URL} target="_blank" rel="noopener noreferrer">
                        {OFFICE_ADDRESS}
                      </a>
                    </p>
                    <p className="method-description">Tenerife, Canarias</p>
                  </div>
                </div>
              </div>

              <div className="contact-benefits">
                <h4 className="benefits-title">¿Por qué elegir E-ASY?</h4>
                <div className="benefits-list">
                  <div className="benefit-item">
                    <div className="benefit-icon">✓</div>
                    <span className="benefit-text">Consultoría gratuita sin compromiso</span>
                  </div>
                  <div className="benefit-item">
                    <div className="benefit-icon">✓</div>
                    <span className="benefit-text">Respuesta en menos de 24 horas</span>
                  </div>
                  <div className="benefit-item">
                    <div className="benefit-icon">✓</div>
                    <span className="benefit-text">Soluciones personalizadas a tu medida</span>
                  </div>
                  <div className="benefit-item">
                    <div className="benefit-icon">✓</div>
                    <span className="benefit-text">Soporte técnico 24/7</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
    </>
  );
};

export default ContactPage;
